var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invite-contact-modal" }, [
    _c("p", { staticClass: "title" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("handover.arrangeNotify")) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          "actual-handover-date",
          { "actual-handover-date-error": _vm.scheduledTransactionDateError },
        ],
      },
      [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("handover.scheduledTransactionDateAndTime"))),
        ]),
        _vm._v(" "),
        _c("date-time-selector", {
          attrs: {
            timeOptions: _vm.options,
            date: _vm.scheduledTransactionDate,
            setMinTime: true,
            disabledDates: { to: _vm.yesterday },
          },
          on: {
            updateDate: function (val) {
              return _vm.updateScheduledTransactionDate(val)
            },
          },
        }),
        _vm._v(" "),
        _vm.scheduledTransactionDateError
          ? _c("error-tip", {
              attrs: {
                extendClass: _vm.datePickErr,
                context: _vm.$t("hint.inputTip.string"),
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "contact-info hkld-contact" }, [
      _c(
        "div",
        { staticClass: "main-contact info" },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("handover.hklContactName"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.selectedUser, function (user, index) {
            return _c(
              "div",
              { key: index, staticClass: "multi-content" },
              [
                _c("HKLSelect", {
                  staticClass: "hkl-select_search-input-flush",
                  class: { "error-highlight": user.emptyUser },
                  attrs: {
                    value: user.id || undefined,
                    options: _vm.getHkldUserHklOptions(index),
                    showSearch: true,
                    placeholder: "",
                  },
                  on: {
                    change: function (val) {
                      return _vm.updateSelect(val, index)
                    },
                  },
                }),
                _vm._v(" "),
                _c("i", {
                  class: ["fa fa-lg", index ? "fa-times" : "fa-plus"],
                  on: {
                    click: function ($event) {
                      index
                        ? _vm.deleteSelectedUser(index)
                        : _vm.addEditabelMultiSelect()
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contact-info" }, [
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "main-contact info" }, [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("handover.handoverContactName"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                return [
                  _c("InputField", {
                    key: fullnameObj.key + ".input",
                    attrs: {
                      extendClass: _vm.contactInfo[fullnameObj.value].error
                        ? "error-highlight"
                        : "",
                      showColon: false,
                      showFlag: false,
                      placeholder: _vm.$t("contact.basic." + fullnameObj.label),
                      value: _vm.contactInfo[fullnameObj.value].value,
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.updateItemValue(fullnameObj.value, val)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.contactInfo[fullnameObj.value].error
                    ? _c("error-tip", {
                        key: fullnameObj.key + ".error",
                        attrs: {
                          extendClass: fullnameObj.value + "Err",
                          showTip: true,
                          context: _vm.$t("hint.inputTip.name"),
                        },
                      })
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "phone-number info" },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("handover.handoverContactPhoneNumber"))),
            ]),
            _vm._v(" "),
            _c("InputField", {
              attrs: {
                extendClass: _vm.contactInfo.phoneNumber.error
                  ? "error-highlight"
                  : "",
                showColon: false,
                showFlag: false,
                value: _vm.contactInfo.phoneNumber.value,
              },
              on: {
                updateValue: function (val) {
                  return _vm.updateItemValue("phoneNumber", val)
                },
              },
            }),
            _vm._v(" "),
            _vm.contactInfo.phoneNumber.error
              ? _c("error-tip", {
                  attrs: {
                    showTip: true,
                    context: _vm.$t("hint.inputTip.phone"),
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "email info" },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("handover.handoverContactEmail"))),
          ]),
          _vm._v(" "),
          _c("InputField", {
            staticClass: "email",
            attrs: {
              extendClass: _vm.contactInfo.email.error ? "error-highlight" : "",
              showColon: false,
              showFlag: false,
              value: _vm.contactInfo.email.value,
            },
            on: {
              updateValue: function (val) {
                return _vm.updateItemValue("email", val)
              },
            },
          }),
          _vm._v(" "),
          _vm.contactInfo.email.error
            ? _c("error-tip", {
                attrs: {
                  showTip: true,
                  context: _vm.$t("hint.inputTip.email"),
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "email info" },
        [
          _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("cc")))]),
          _vm._v(" "),
          _c("TextField", {
            attrs: {
              extendClass: _vm.contactInfo.additionalEmails.error
                ? "error-highlight"
                : "",
              value: _vm.contactInfo.additionalEmails.value,
            },
            on: {
              updateValue: function (val) {
                return _vm.updateItemValue("additionalEmails", val)
              },
            },
          }),
          _vm._v(" "),
          _vm.contactInfo.additionalEmails.error
            ? _c("error-tip", {
                attrs: {
                  showTip: true,
                  context: _vm.$t("hint.inputTip.email"),
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "remark info" },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("handover.remarkToTenant"))),
          ]),
          _vm._v(" "),
          _c("TextField", {
            attrs: {
              showColon: false,
              showFlag: false,
              value: _vm.remarkToTenant,
              placeholder: "",
            },
            on: {
              updateValue: function (val) {
                return _vm.updateRemark(val)
              },
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "group-btns" }, [
      _c(
        "div",
        { staticClass: "confirm btn--orange", on: { click: _vm.confirm } },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("handover.arrangeNotify")) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cancel btn--darkblue", on: { click: _vm.cancel } },
        [_vm._v("\n      " + _vm._s(_vm.$t("action.cancel")) + "\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }